module.exports = __webpack_public_path__ + "static/media/Nephrology  Kidney Diseases.df8d5601.png";